var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.914,
    height: 38.262,
    viewBox: "0 0 45.914 38.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_1_",
    "data-name": "upload (1)",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75394",
    "data-name": "Path 75394",
    d: "M5.913,17.3A1.807,1.807,0,0,1,4,15.392,13.309,13.309,0,0,1,17.392,2a13.74,13.74,0,0,1,12.818,9.374,1.816,1.816,0,0,1-1.339,2.3,1.99,1.99,0,0,1-2.487-1.148,9.242,9.242,0,0,0-8.992-6.7,9.473,9.473,0,0,0-9.565,9.565A1.807,1.807,0,0,1,5.913,17.3Z",
    transform: "translate(3.652 0)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75395",
    "data-name": "Path 75395",
    d: "M30.783,28.957a1.913,1.913,0,0,1,0-3.826,7.652,7.652,0,0,0,0-15.3,6.508,6.508,0,0,0-1.913.191,1.967,1.967,0,0,1-2.3-1.339,1.967,1.967,0,0,1,1.339-2.3A14.767,14.767,0,0,1,30.783,6a11.479,11.479,0,1,1,0,22.957Zm-19.131,0H5.913a1.913,1.913,0,0,1,0-3.826h5.739a1.913,1.913,0,0,1,0,3.826Z",
    transform: "translate(3.652 3.652)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75396",
    "data-name": "Path 75396",
    d: "M34.436,27.131H30.61a1.913,1.913,0,1,1,0-3.826h3.826a1.913,1.913,0,0,1,0,3.826Zm-24.87,0A9.473,9.473,0,0,1,0,17.565,9.473,9.473,0,0,1,9.565,8a1.807,1.807,0,0,1,1.913,1.913,1.807,1.807,0,0,1-1.913,1.913,5.637,5.637,0,0,0-5.739,5.739A5.637,5.637,0,0,0,9.565,23.3a1.913,1.913,0,0,1,0,3.826Zm13.392,7.652a1.807,1.807,0,0,1-1.913-1.913V13.739a1.913,1.913,0,1,1,3.826,0V32.87A1.807,1.807,0,0,1,22.957,34.783Z",
    transform: "translate(0 5.479)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75397",
    "data-name": "Path 75397",
    d: "M9.913,19.565a1.737,1.737,0,0,1-1.339-.574,1.849,1.849,0,0,1,0-2.678l5.739-5.739a1.894,1.894,0,0,1,2.678,2.678l-5.739,5.739A1.737,1.737,0,0,1,9.913,19.565Z",
    transform: "translate(7.305 7.305)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75398",
    "data-name": "Path 75398",
    d: "M18.652,19.565a1.737,1.737,0,0,1-1.339-.574l-5.739-5.739a1.894,1.894,0,0,1,2.678-2.678l5.739,5.739a1.849,1.849,0,0,1,0,2.678A1.737,1.737,0,0,1,18.652,19.565Z",
    transform: "translate(10.044 7.305)",
    fill: "#7e7e7e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGrey);
export default __webpack_public_path__ + "static/media/upload-grey.165782b0763247d8cc3d6b441d96cc3c.svg";
export { ForwardRef as ReactComponent };